<mat-dialog-content style="font-family: Roboto">
  @if (this.Report) {
    <table>
      <tr>
        <td>
          @if (this.Report.SCReport.Player.CurrentTeamIconFileName != null) {
            <img
              style="height: 48px"
          [src]="
            '../../assets/img/' +
            this.Report.SCReport.Player.CurrentTeamIconFileName
          "
              />
          }
        </td>
        <td>
          <span style="font-size: large; color: white"
            >{{ this.Report.SCReport.Player.LastName }},
            {{ this.Report.SCReport.Player.FirstName }}</span
            >
            <div style="font-size: medium; color: gray; font-size: 12px">
              @if (this.Report.PositionId === 1) {
                <span> Goaltender </span>
              }
              @if (
                this.Report.SCReport.Player.PositionId === 2 ||
                this.Report.SCReport.Player.PositionId === 3
                ) {
                <span
                  >
                  Defender
                </span>
              }
              @if (this.Report.SCReport.Player.PositionId > 3) {
                <span>
                  Forward
                </span>
              }
              <span>
                {{ this.Report.DateOfBirth | date : "yyyy-MM-dd" }} ({{
                this.Report.PlayerAgeYears +
                " Years " +
                this.Report.PlayerAgeMonths +
                " Months"
                }})
              </span>
              <br />
              @if (
                this.Report.ReportDivision != null &&
                this.Report.ReportTeamName != null
                ) {
                <span
                  >
                  {{ this.Report.ReportDivision + "/" + this.Report.ReportTeamName
                  }}<br />
                </span>
              }
              @if (
                this.Report.ReportDivision === null ||
                this.Report.ReportTeamName === null
                ) {
                <span
                  >
                  {{
                  this.Report.PlayerCurrentDivision +
                  "/" +
                  this.Report.PlayerCurrentTeam
                  }}<br />
                </span>
              }
            </div>
          </td>
        </tr>
      </table>
    }
    <mat-divider></mat-divider>
    @if (this.Report) {
      <div style="max-width: 748px">
        {{ this.Report.SCReport.ReportTexts[0].Text }}
      </div>
    }
    <mat-divider></mat-divider>
    <!--   <app-report-overall-game *ngIf="this.Report?.Game"
    [GameText]="this.Report.Game.TeamHomeName + '-' + this.Report.Game.TeamAwayName"
    [GameDivision]="this.Report.Game.DivisionName" [GamePerformanceText]="this.Report.GamePerformanceText"
    [GamePerformance]="this.Report.GamePerformance.Ranking" [ScoutingSourceText]="this.Report.SCReport.ScoutingSourceText"
  [Position]="this.Report.SCReport.PositionText"></app-report-overall-game>
  <mat-divider></mat-divider>
  -->
  @if (this.Report?.Game) {
    <app-report-overall-game
    [GameText]="
      this.Report.Game.TeamHomeName + '-' + this.Report.Game.TeamAwayName
    "
      [GameDivision]="this.Report.Game.DivisionName"
      [GamePerformanceText]="this.Report.GamePerformanceText"
      [GamePerformance]="this.Report.GamePerformance"
      [ScoutingSourceText]="this.Report.SCReport.ScoutingSourceText"
      [Position]="this.Report.PositionText"
    ></app-report-overall-game>
  }
  <mat-divider></mat-divider>
  @if (this.Report) {
    <app-report-overall-grades
      [TotalQualityText]="this.Report.TotalQualityText"
      [TotalQuality]="this.Report.TotalQuality.Ranking"
      [PlayerType]="this.Report.PlayerType.Ranking"
      [PlayerTypeText]="this.Report.PlayerTypeText"
      [CapacityText]="this.Report.PlayerCapacityText"
      [Capacity]="this.Report.PlayerCapacity.Ranking"
    ></app-report-overall-grades>
  }
  <mat-divider></mat-divider>
  @if (this.Report) {
    <app-report-overall-skillsgroup
      [SkillsGroups]="this.Report.SkillGroups"
    ></app-report-overall-skillsgroup>
  }
  @if (this.Report) {
    <div
    style="
      font-family: Roboto;
      font-size: x-small;
      text-align: left;
      vertical-align: top;
      padding: 0;
      white-space: normal;
      margin: 0;
      color: white;
    "
      >
      <table>
        <tr>
          <td>
            <mat-icon style="color: orange; font-size: 18px;font-family: 'Material Icons';">person</mat-icon>
          </td>
          <td>
            <div style="font-size: 10px;font-family: Roboto;">
              {{ this.Report.SCReport.ScoutLastName }},
              {{ this.Report.SCReport.ScoutFirstName }}
            </div>
            <span style="color: gray; font-size: 10px; color: gray">{{
              this.Report.SCReport.DateCreated | date : "yyyy-MM-dd HH:mm"
            }}</span>
          </td>
        </tr>
        @if (this.Report.Game) {
          <tr>
            <td style="text-align: top">
              <mat-icon style="color: orange; font-size: 18px;"
                >sports_hockey</mat-icon
                >
              </td>
              <td>
                <div style="font-size: 10px">
                  {{ this.Report.Game.TeamHomeName }}-{{
                  this.Report.Game.TeamAwayName
                  }}
                  <br />
                  <span>{{ this.Report.Division }}</span>
                </div>
                <app-player-game-statistics-small
                  [Statistics]="this.Report.GameStatistics"
                  Selection="G,A,TP,+/-"
                ></app-player-game-statistics-small>
              </td>
            </tr>
          }
          <tr>
            <td>
              <mat-icon style="color: orange; font-size: 18px;font-family: 'Material Icons';">
                location_on</mat-icon
                >
              </td>
              <td>
                <div style="font-size: 10px">
                  {{ this.Report.SCReport.Location }}
                </div>
              </td>
            </tr>
          </table>
        </div>
      }
    </mat-dialog-content>

    <mat-dialog-actions>
      <button mat-button (click)="close()">CLOSE</button>
    </mat-dialog-actions>
